import React from 'react';
import { bool, string } from 'prop-types';
import { utcToZonedTime } from 'date-fns-tz';
import { humanized_time_span } from 'utils/humanized_time_span';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
import LanguageRegionCode from '@alltrails/shared/types/LanguageRegionCode';

export function formatDateStringWithTimezone(dateString, locale, timezone) {
  let dateObj = new Date(dateString);
  if (timezone) {
    dateObj = utcToZonedTime(dateString, timezone);
  }

  return dateObj.toLocaleDateString(locale || LanguageRegionCode.English, { year: 'numeric', month: 'long', day: 'numeric' });
}

export default function CardDate({ className, dateString, locale, timezone, humanizeTime }) {
  if (!dateString) {
    return null;
  }

  const timeText = humanizeTime ? humanized_time_span(dateString, locale) : formatDateStringWithTimezone(dateString, locale, timezone);
  return <span className={`${className} ${StringConstantsMixin.constants.XLATE.NONE}`}>{timeText}</span>;
}

CardDate.propTypes = {
  className: string,
  dateString: string,
  locale: string,
  timezone: string,
  humanizeTime: bool
};
